export const info = 
[
    {
        tipo: 'numerico',
        titulo: 'Números reales',
        ejemplos: [
            {
                id: 1, 
                ejemplo: '$\\dfrac{a}{b}$ se escribe <code>a/b</code>'
            },
            {
                id: 2, 
                ejemplo: '$a^{n}$, se escribe <code>a^n</code>'
            },
            {
                id: 3, 
                ejemplo: '$\\sqrt{a}$, se escribe <code>sqrt(a)</code>'
            },
            {
                id: 4, 
                ejemplo: 'El decimal $n{,}m$ se escribe <code>n.m</code>'
            },
            {
                id: 5, 
                ejemplo: 'El símbolo $\\infty$ se escribe <code>inf</code>'
            },
            {
                id: 6, 
                ejemplo: '$\\log_{a}(x)$ se escribe <code>log(x,a)</code>'
            },
            {
                id: 7, 
                ejemplo: '$\\ln(x)$ se escribe <code>log(x,e)</code>'
            },
            {
                id: 8, 
                ejemplo: '$\\arctan(x)$ se escribe <code>atan(x)</code>'
            },
            {
                id: 9, 
                ejemplo: '$\\arcsin(x)$ se escribe <code>atan(x)</code>'
            },
            {
                id: 10, 
                ejemplo: '$\\arccos(x)$ se escribe <code>acos(x)</code>'
            }
        ]
    },
    {
        tipo: 'antiderivada',
        titulo: 'Antiderivada',
        ejemplos: [
            {
                id: 1, 
                ejemplo: 'Si \\(F\\) es una antiderivada de \\(f\\), entonces \\[\\int f(x)\\,dx = F(x)+C\\] siendo \\(C\\) una constante. La expresión \\(F(x)+C\\) es la <b>antiderivada general</b> de \\(f\\).'
            }
        ]
    },
    {
        tipo: 'intervalo',
        titulo: 'Conjunto',
        ejemplos: [
            {
                id: 1, 
                ejemplo: '$\\infty$ se escribe <code>inf</code>'
            },
            {
                id: 2, 
                ejemplo: '$-\\infty$ se escribe <code>-inf</code>'
            },
            {
                id: 3, 
                ejemplo: '$\\big\\{ a , b, c \\big\\}$ se escribe <code>{a,b,c}</code>'
            },
            {
                id: 4, 
                ejemplo: '$\\big( a , b \\big)$ se escribe <code>(a,b)</code>'
            },
            {
                id: 5, 
                ejemplo: '$\\big[ a , b \\big)$ se escribe <code>[a,b)</code>'
            },
            {
                id: 6, 
                ejemplo: '$\\big( a , b \\big]$ se escribe <code>(a,b]</code>'
            },
            {
                id: 7, 
                ejemplo: '$\\big[ a , b \\big]$ se escribe <code>[a,b]</code>'
            },
            {
                id: 8, 
                ejemplo: '$A \\cup B$ se escribe <code>A U B</code>'
            },
        ]
    },
    {
        tipo: 'formula',
        titulo: 'Fórmula en la variable $x$',
        ejemplos: [
            {
                id: 1, 
                ejemplo: '$2x^3+1$ se escribe <code>2x^3+1</code>'
            },
            {
                id: 2, 
                ejemplo: '$(x+3)(x-2)$ se escribe <code>(x+3)(x-2)</code>'
            },
            {
                id: 3, 
                ejemplo: '$\\dfrac{x+1}{x^2-1}$ se escribe <code>(x+1)/(x^2-1)</code>'
            },
            {
                id: 4, 
                ejemplo: '$\\sqrt{3-4x}$ se escribe <p><code>sqrt(3-4x)</code></p>'
            },
            {
                id: 5, 
                ejemplo: '$\\log_{a}(x)$ se escribe <code>log(x,a)</code>'
            },
            {
                id: 6, 
                ejemplo: '$\\ln(x)$ se escribe <code>log(x,e)</code>'
            }, 
            {
                id: 7, 
                ejemplo: '$\\sin(x)$ se escribe <code>sin(x)</code>'
            }, 
            {
                id: 8, 
                ejemplo: '$\\cos(x)$ se escribe <code>cos(x)</code>'
            }, 
            {
                id: 9, 
                ejemplo: '$\\tan(x)$ se escribe <code>tan(x)</code>'
            },
            {
                id: 10, 
                ejemplo: '$\\cot(x)$ se escribe <code>cot(x)</code>'
            }, 
            {
                id: 11, 
                ejemplo: '$\\csc(x)$ se escribe <code>csc(x)</code>'
            }, 
            {
                id: 12, 
                ejemplo: '$\\sec(x)$ se escribe <code>sec(x)</code>'
            }, 
            {
                id: 13, 
                ejemplo: '$e^{x}$ se escribe <code>e^{x}</code>'
            },
            {
                id: 14, 
                ejemplo: '$\\arctan(x)$ se escribe <code>atan(x)</code>'
            },
            {
                id: 15, 
                ejemplo: '$\\arcsin(x)$ se escribe <code>atan(x)</code>'
            },
            {
                id: 16, 
                ejemplo: '$\\arccos(x)$ se escribe <code>acos(x)</code>'
            }
        ]
    },
    {
        tipo: 'ecuacionXY',
        titulo: 'Ecuacion en las variables $x$ e $y$',
        ejemplos: [
            {
                id: 1, 
                ejemplo: '$ax+by+c=0$ se escribe <p><code>a*x+b*y+c=0</code></p>'
            },
            {
                id: 2, 
                ejemplo: '$y=mx+n$ se escribe <p><code>y=m*x+n</code></p>'
            },
            {
                id: 3, 
                ejemplo: '$y-b=m(x-a)$ se escribe <p><code>y-b=m*(x-a)</code></p>'
            },
            {
                id: 4, 
                ejemplo: '$y=ax^2+bx+c$ se escribe <p><code>y=a*x^2+b*x+c</code></p>'
            }
        ]
    },
    {
        tipo: 'vector',
        titulo: 'Vector',
        ejemplos: [
            {
                id: 1, 
                ejemplo: 'El vector de \\(\\R^{2}\\) \\[\\begin{bmatrix} a \\\\ b \\end{bmatrix}\\] se escribe <code>[a,b]</code>.'
            },
            {
                id: 2, 
                ejemplo: 'El vector de \\(\\R^{3}\\) \\[\\begin{bmatrix} a \\\\ b \\\\ c \\end{bmatrix}\\] se escribe <code>[a,b,c]</code>.'
            }
        ]
    },
    {
        tipo: 'punto',
        titulo: 'Punto',
        ejemplos: [
            {
                id: 1, 
                ejemplo: 'El punto de coordenadas \\((a,b)\\) se escribe <code>(a,b)</code>.'
            },
            {
                id: 2, 
                ejemplo: 'El punto de coordenadas \\((a,b,c)\\) se escribe <code>(a,b,c)</code>.'
            }
        ]
    },
    // {
    //     tipo: 'conjunto-discreto',
    //     titulo: 'Conjunto discreto de números',
    //     ejemplos: 
    //     `
    //     <div class='resumen mt-2'>
    //         <li class='mt-2'>
    //             El conjunto con un único elemento $a$ se denota por $\\{a\\}$ y se escribe <code>{a}</code>
    //         </li>
    //         <li class='mt-2'>
    //             El conjunto con dos elementos $a$ y $b$ se denota por $\\{a,b\\}$ y se escribe <code>{a,b}</code>
    //         </li>
    //         <li class='mt-2'>
    //             El conjunto con dos elementos $a$, $b$ y $c$ se denota por $\\{a,b,c\\}$ y se escribe <code>{a,b,c}</code>
    //         </li>
    //     </div>

    //     El orden en que se escriben los elementos no importa.
    //     `
    // },
    // {
    //     tipo: 'conjunto-vectores',
    //     titulo: 'Conjunto de puntos',
    //     ejemplos: 
    //     `
    //     <div class='resumen mt-2'>
    //         <li class='mt-2'>
    //             El conjunto con un único punto $(a,b)$ se denota por $\\{(a,b)\\}$ y se escribe <code>{(a,b)}</code>
    //         </li>
    //         <li class='mt-2'>
    //             El conjunto con dos puntos $(a,b)$ y $(c,d)$ se denota por $\\{(a,b),(c,d)\\}$ y se escribe <code>{(a,b),(c,d)}</code>
    //         </li>
    //     </div>

    //     El orden en que se escriben los elementos no importa.
    //     `
    // },
    
    // {
    //     tipo: 'formulaN',
    //     titulo: 'Fórmula en la variable $n$',
    //     ejemplos: 
    //     `
    //     <div class='resumen mt-2'>
    //         <li class='mt-2'>
    //             $2n^3+1$ se escribe <p><code>2n^3+1</code></p>
    //         </li>
    //         <li class='mt-2'>
    //             $(n+3)(n-2)$ se escribe <code>(n+3)(n-2)</code>
    //         </li>
    //         <li class='mt-2'>
    //             $\\dfrac{n+1}{n^2-1}$ se escribe <code>(n+1)/(n^2-1)</code>
    //         </li>
    //         <li class='mt-2'>
    //             $\\sqrt{3-4n}$ se escribe <p><code>sqrt(3-4n)</code></p>
    //         </li>
    //     </div>
    //     `
    // },
    // {
    //     tipo: 'formula',
    //     titulo: 'Fórmula en la variable $x$',
    //     ejemplos: 
    //     `
    //     <div class='resumen mt-2'>
    //         <li class='mt-2'>
    //             $2x^3+1$ se escribe <code>2x^3+1</code>
    //         </li>
    //         <li class='mt-2'>
    //             $(x+3)(x-2)$ se escribe <code>(x+3)(x-2)</code>
    //         </li>
    //         <li class='mt-2'>
    //             $\\dfrac{x+1}{x^2-1}$ se escribe <code>(x+1)/(x^2-1)</code>
    //         </li>
    //         <li class='mt-2'>
    //             $\\sqrt{3-4x}$ se escribe <p><code>sqrt(3-4x)</code></p>
    //         </li>
    //         <li class='mt-2'>
    //             $\\log_{a}(x)$ se escribe <code>log(x,a)</code>
    //         </li>
    //         <li class='mt-2'>
    //             $\\ln(x)$ se escribe <code>log(x,e)</code>
    //         </li>
    //     </div>
    //     `
    // },
    // {
    //     tipo: 'formulaT',
    //     titulo: 'resumen Fórmula en la variable $t$',
    //     ejemplos: 
    //     `
    //     <div class='resumen mt-2'>
    //         <li class='mt-2'>
    //             $2t^3+1$ se escribe <code>2t^3+1</code>
    //         </li>
    //         <li class='mt-2'>
    //             $(t+3)(t-2)$ se escribe <code>(t+3)(t-2)</code>
    //         </li>
    //         <li class='mt-2'>
    //             $\\dfrac{t+1}{t^2-1}$ se escribe <code>(t+1)/(t^2-1)</code>
    //         </li>
    //         <li class='mt-2'>
    //             $\\sqrt{3-4t}$ se escribe <p><code>sqrt(3-4t)</code></p>
    //         </li>
    //     </div>
    //     `
    // }
]
    